module.exports = __webpack_public_path__ + "static/media/playertable icon-3.466cc209.svg";